import { useCallback } from 'react'
import { useRouter } from 'next/router'

import useAppDispatch from '../../../store/hooks/useAppDispatch'
import useAppStore from '../../../store/hooks/useAppStore'
import { outletsSelectedOutletListItemUrlSlugSelector } from '../../outlets/store/outletsSelectors'
import {
  preOrderNewOrderOrderFormatSelector,
  preOrderNewOrderSelectedOrderMethodSelector,
  preOrderNewOrderTimeSelector,
} from '../store/preOrderSelectors'
import {
  closeNewOrderPanel,
  setNewOrderDetails,
  setNewOrderPanelCreatedGroupOrderStatus,
} from '../store/preOrderSlice'
import { createGroupPreOrder } from '../store/preOrderThunks'
import { PreOrderMethod } from '../types'
import getPreOrderPageURL from '../utils/getPreOrderPageURL'

/**
 * Finishes the new order panel: a normal order continues on the menu with
 * the chosen format and time, a group order is created for the team
 */
export default function useCompleteNewOrder() {
  const dispatch = useAppDispatch()
  const store = useAppStore()
  const router = useRouter()

  return useCallback(async () => {
    const state = store.getState()
    const orderMethod = preOrderNewOrderSelectedOrderMethodSelector(state)

    if (orderMethod === PreOrderMethod.Group) {
      try {
        const { preOrderStatus } = await dispatch(
          createGroupPreOrder(),
        ).unwrap()

        dispatch(setNewOrderPanelCreatedGroupOrderStatus(preOrderStatus))
      } catch {
        // createGroupPreOrder tells the user what went wrong
      }

      return
    }

    const urlSlug = outletsSelectedOutletListItemUrlSlugSelector(state)
    const orderFormat = preOrderNewOrderOrderFormatSelector(state)
    const orderTime = preOrderNewOrderTimeSelector(state)

    dispatch(
      setNewOrderDetails({
        orderMethod: PreOrderMethod.Individual,
        groupOrderName: null,
        groupOrderSize: null,
      }),
    )

    // The last step can't be completed without a restaurant, format and time
    await router.push(getPreOrderPageURL(urlSlug!, orderFormat!, orderTime!))

    dispatch(closeNewOrderPanel())
  }, [dispatch, router, store])
}
